import React, { useEffect, useState } from "react";
import { Typography, Box, Button } from '@mui/material';
import { Dialog, useToggle } from '@genesis/ui-kit';
import axios from "axios";
import axiosInstance from "../../../../Shared/Utill/AxiosConfig";
import { constants, environmentVariables } from "../../../../Shared/Url/Constants";
import { useSelector } from "react-redux";
import Cookie from "js-cookie";
import { IsTokenValid } from "../../../../Shared/Utill/AuthUtil";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import eventClasses from "./locationcontrols.module.scss";
import {DialogTitle} from "@mui/material";
import SnackBar from "../../../../Shared/Snackbar/Snackbar";

const DeleteEventDialog = (props) => {
    const dialog = useToggle();
    const personDetails = useSelector((state) => state.person.personData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const token = Cookie.get('X_TKN');
    const [isAlertOpen, setAlertOpen] = React.useState({});
    const { message, severity, open } = isAlertOpen || {};

    useEffect(() => {
        if (props.locNbr === 0 && props.flag === "S") {
            props.onDeleteCallback("error","You cannot delete Location 0");
        } else {
            dialog.show();
        }
        
    }, []);

    const deleteEventAction = () => {
        // call delet event  api
        console.log("the flag is not changing?",props.flag)
        console.log("request payload",props.data)
        console.log("request payload",props.divNbr)
        callDeleteService(props.divNbr,props.locNbr);
       
    }

    const callDeleteService = (divnbr,locnbr) =>{
        let data = {
            divNbr:divnbr,
            locNbr:locnbr,
            appAbbr:"avl"
        }
       
       axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_DELETE_ADMIN_EVENT_LOCATION_CONTROLS_BY_DIV_AND_LOC}`,
       data, 
       {
            headers: {
            'content-type': 'application/json',
            'Authorization': 'Bearer ' + token
            }
        })
        .then((response) => {
         console.log("response is",response.data);
         if(response.status === 200){
          // success close popup
          props.onDeleteCallback("success","Division " + props.divNbr +" Location " + props.locNbr+ " deleted successfully.");    
         }else{
            props.onDeleteCallback("error","Something went wrong"); 
         }
        })
        .catch((error) => {
           //catch
         props.onDeleteCallback("error",error.response.data.message); 
        })
    }
  
    const handleAlertNotifClose = () => {
        setAlertOpen({});
     };
    
    const closeDialog = () => {
        dialog.hide();
        props.onCloseDialog(); 
    }
    if (props.locNbr === 0 && props.flag === "S"){
        return (
        <div className={eventClasses.dontDeleteZeroForSearch}>   
        <SnackBar
        open={open}
        message={"You cannot delete Location 0"}
        severity={"error"}
        onClose={handleAlertNotifClose}
        ></SnackBar>
        </div> 
        )
    }
    

     if (props.locNbr === 0 && props.flag !== "S") {
        return (
            <Box>
            <Dialog
                open={dialog.open}
                title={<DialogTitle sx={{fontSize:"22px",fontWeight:"300px"}}>{"Delete Location " + props.locNbr}</DialogTitle>}
                onClose={closeDialog}
                actions={
                    <>
                        <Button color="primary" onClick={() => closeDialog()}>OK</Button>
                        
                    </>
                }
            >
            <div className={eventClasses.combinedMessage}>
            <ReportProblemIcon sx={{ color: "DarkRed", position: "absolute" }}></ReportProblemIcon>  
            <Typography sx={{color:"DarkRed", marginLeft: "50px" }}>{"You cannot delete Location "  + props.locNbr+ "."}</Typography>
            </div>
                
            </Dialog>
        </Box>
        )
    } else if (props.locNbr !== 0) {
        return (
            <Box>
                <Dialog
                    open={dialog.open}
                    title={"Confirm Delete Event"}
                    onClose={closeDialog}
                    actions={
                        <>
                            <Button color="secondary" onClick={() => closeDialog()}>No</Button>
                            <Button onClick={() => deleteEventAction()}>Yes</Button>
                        </>
                    }
                >
                    <Typography>{"Are you sure you want to delete Div " + props.divNbr + " Loc " + props.locNbr+ "?"}</Typography>
                </Dialog>
            </Box>
        );
    }
    
}

export default DeleteEventDialog;

